<form class="md-menu content" style="max-height: calc(100vh - 8.25rem)">
  <div class="layout-auto-1-auto" style="width: max-content">
    <!--FILTER-->
    <ng-container *ngIf="showFilter">
      <div class="md-menu-header">{{getLokalTranslation('Globals.PopupHeaderFilter')}}</div>
      <div class="content" [class]="containerClass">
        <ng-container *ngFor="let f of uiFilter; let i = index;">
          <ng-container *ngIf="f.filterType==1">
            <h3 *ngIf="i == 0 || i > 0 && f.filterGroup != uiFilter[i-1].filterGroup">{{getLokalTranslation(f.filterGroup)}}</h3>
            <exg-switch [caption]="getLokalTranslation(f.uiCaption)" name="{{f.uiName}}" style="overflow: visible"
                        [(ngModel)]="f.uiValue"  [tooltip]="f.uiTooltip"></exg-switch>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
    <!--SORTIERUNG-->
    <ng-container *ngIf="showSort">
      <div class="md-menu-header">{{getLokalTranslation('Globals.PopupHeaderSort')}}</div>
      <div class="content" [class]="containerClass">
        <ng-container *ngFor="let s of uiSort; let i = index;">
          <h3 *ngIf="i == 0 || i > 0 && s.sortGroup != uiSort[i-1].sortGroup">{{getLokalTranslation(s.sortGroup)}}</h3>
          <div class="md-menu-item-sort" (click)="ChangeSortValue(s)"  [tooltip]="s.uiTooltip">
            <i class="fa-fw" [class.fad]="s.uiValue > 0" [class.fal]="s.uiValue == 0"
               [ngClass]="{'fa-sort' : s.uiValue == 0,'fa-sort-up' : s.uiValue == 1,'fa-sort-down' : s.uiValue == 2 }"></i>
            {{getLokalTranslation(s.uiCaption)}}
          </div>
        </ng-container>
      </div>
    </ng-container>
    <!--SUCHE-->
    <ng-container *ngIf="showSearch">
      <div class="md-menu-header">{{getLokalTranslation('Globals.PopupHeaderSearch')}}</div>
      <div class="content" [class]="containerClass">
        <ng-container *ngFor="let f of uiFilter; let i = index;">
          <ng-container *ngIf="f.filterType==2">
            <h4 *ngIf="i == 0 || i > 0 && f.filterGroup != uiFilter[i-1].filterGroup">{{getLokalTranslation(f.filterGroup)}}</h4>
            <exg-input [caption]="getLokalTranslation(f.uiCaption)" name="{{f.uiName}}"
                       [(ngModel)]="f.filterCondition.value" [tooltip]="f.uiTooltip"
                       (change)="ChangeSearchValue(f)"></exg-input>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
    <div class="md-menu-footer">
      <button class="md-btn" type="button" (click)="ResetFilter()">{{getLokalTranslation('Globals.Reset')}}</button>
      <button class="md-btn" type="submit" (click)="ApplyFilter()">{{getLokalTranslation('Globals.Apply')}}</button>
    </div>
  </div>
</form>
